import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { getPersistor } from '@rematch/persist';

import 'semantic-ui-css/semantic.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './themes/light-theme.css';
import './components/layout/header/styles.css';
import './components/layout/styles.css';
import './index.css';

//JQuery dependency added only for JIRA integration. 
import './helpers/jquery-loader';

import { store } from './state';
import App from './App';
import { unregister } from './registerServiceWorker';

render(
    <Provider store={store}>
        <PersistGate persistor={getPersistor()}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

unregister();
